import React from 'react';
import { IPlayer, allGradients, GradientColorPair } from 'stores/appStore';
import styles from './PlayerSettingsModal.css';

interface Props {
    player: IPlayer;
    baseColors: string[];
    additionalColors: string[];
    onClose: () => void;
}

const PlayerSettingsModal = ({ player, baseColors, additionalColors, onClose }: Props) => {
    const handleNameChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        player.setName(e.target.value);
    };

    const handleGradientSelect = (gradient: GradientColorPair) => {
        player.setBackgroundColor(gradient[0]);
    };

    const renderGradientOption = (gradient: GradientColorPair, index: number) => {
        const isActive = player.backgroundColor === gradient[0];
        return (
            <button
                key={`gradient-${index}`}
                className={`${styles.colorOption} ${isActive ? styles.activeColorOption : styles.inactiveColorOption}`}
                onClick={() => handleGradientSelect(gradient)}
            >
                <div
                    className={styles.gradientFill}
                    style={{
                        background: `linear-gradient(135deg, ${gradient[0]}, ${gradient[1]})`,
                    }}
                />
            </button>
        );
    };

    return (
        <div className={styles.container}>
            <div className={styles.section}>
                <span className={styles.sectionTitle}>Name</span>
                <input
                    className={styles.nameInput}
                    value={player.name}
                    onChange={handleNameChange}
                    placeholder={`Player ${player.id}`}
                />
            </div>

            <div className={`${styles.section} ${styles.lastSection}`}>
                <span className={styles.sectionTitle}>Colors</span>
                <div className={styles.colorGrid}>
                    {allGradients.map(renderGradientOption)}
                </div>
            </div>
        </div>
    );
};

export default PlayerSettingsModal;
